import { render, staticRenderFns } from "./OnlineConsultDialog.vue?vue&type=template&id=0b5ba6f2&scoped=true&"
import script from "./OnlineConsultDialog.vue?vue&type=script&lang=js&"
export * from "./OnlineConsultDialog.vue?vue&type=script&lang=js&"
import style0 from "./OnlineConsultDialog.vue?vue&type=style&index=0&id=0b5ba6f2&prod&scoped=true&lang=css&"
import style1 from "./OnlineConsultDialog.vue?vue&type=style&index=1&id=0b5ba6f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ba6f2",
  null
  
)

export default component.exports